import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "row gy-5 g-xl-10 gap-5 gap-xl-0" }
const _hoisted_3 = { class: "col-xl-9" }
const _hoisted_4 = { class: "row g-5 g-xl-10" }
const _hoisted_5 = { class: "col-xxl-12" }
const _hoisted_6 = { class: "card mb-5 mb-xl-10" }
const _hoisted_7 = { class: "card-header flex-max-sm-column max-sm-align-items-start" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_12 = { class: "text-gray-400 ms-2" }
const _hoisted_13 = { class: "card-body p-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "form-label fw-bold required" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold required" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "form-label fw-bold" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "form-label fw-bold" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "form-label fw-bold required" }
const _hoisted_25 = { class: "col-md-12 form-group mb-7" }
const _hoisted_26 = { class: "form-label fw-bold fs-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6 form-group mb-7" }
const _hoisted_30 = { class: "form-label fw-bold required" }
const _hoisted_31 = { class: "col-md-6 form-group mb-7" }
const _hoisted_32 = { class: "form-label fw-bold required" }
const _hoisted_33 = { class: "col-md-6 form-group mb-7" }
const _hoisted_34 = { class: "form-label fw-bold" }
const _hoisted_35 = { class: "col-md-6 form-group mb-7" }
const _hoisted_36 = { class: "form-label fw-bold" }
const _hoisted_37 = { class: "col-md-12 form-group mb-7" }
const _hoisted_38 = { class: "form-label fw-bold" }
const _hoisted_39 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_40 = { class: "d-flex gap-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_42 = { class: "indicator-label" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_44 = { class: "indicator-progress" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "svg-icon svg-icon-2" }
const _hoisted_49 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "svg-icon svg-icon-2" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "indicator-label" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_56 = { class: "indicator-progress" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_58 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_59 = { class: "card-header flex-max-sm-column max-sm-align-items-start" }
const _hoisted_60 = { class: "card-title align-items-start flex-column" }
const _hoisted_61 = ["title"]
const _hoisted_62 = { class: "card-toolbar" }
const _hoisted_63 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_64 = { class: "text-gray-400 ms-2" }
const _hoisted_65 = { class: "card-body p-9" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-6 form-group mb-7" }
const _hoisted_68 = { class: "form-label fw-bold" }
const _hoisted_69 = { class: "col-md-6 form-group mb-7" }
const _hoisted_70 = { class: "form-label fw-bold" }
const _hoisted_71 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_72 = { class: "form-label fw-bold" }
const _hoisted_73 = { class: "col-md-6 form-group mb-7" }
const _hoisted_74 = { class: "form-label fw-bold" }
const _hoisted_75 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " % ", -1)
const _hoisted_77 = { class: "col-md-12 form-group mb-7" }
const _hoisted_78 = { class: "form-label fw-bold" }
const _hoisted_79 = { class: "col-md-12 form-group mb-7" }
const _hoisted_80 = { class: "form-label fw-bold" }
const _hoisted_81 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_82 = { class: "d-flex gap-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_84 = { class: "indicator-label" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_86 = { class: "indicator-progress" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { class: "svg-icon svg-icon-2" }
const _hoisted_91 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "svg-icon svg-icon-2" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { class: "indicator-label" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_98 = { class: "indicator-progress" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_100 = { class: "card mb-5 mb-xl-10" }
const _hoisted_101 = { class: "card-header flex-max-sm-column max-sm-align-items-start" }
const _hoisted_102 = { class: "card-title align-items-start flex-column" }
const _hoisted_103 = ["title"]
const _hoisted_104 = { class: "card-toolbar" }
const _hoisted_105 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_106 = { class: "text-gray-400 ms-2" }
const _hoisted_107 = { class: "card-body p-9" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-md-6 form-group mb-7" }
const _hoisted_110 = { class: "form-label fw-bold required" }
const _hoisted_111 = { class: "col-md-6 form-group mb-7" }
const _hoisted_112 = { class: "form-label fw-bold required" }
const _hoisted_113 = { class: "col-md-6 form-group mb-7" }
const _hoisted_114 = { class: "form-label fw-bold" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "col-md-6 form-group mb-7" }
const _hoisted_117 = { class: "form-label fw-bold" }
const _hoisted_118 = { class: "col-md-6 form-group mb-7" }
const _hoisted_119 = { class: "form-label fw-bold" }
const _hoisted_120 = { class: "col-md-6 form-group mb-7" }
const _hoisted_121 = { class: "form-label fw-bold" }
const _hoisted_122 = { class: "col-md-6 form-group mb-7" }
const _hoisted_123 = { class: "form-label fw-bold" }
const _hoisted_124 = { class: "col-md-12 form-group mb-7" }
const _hoisted_125 = { class: "form-label fw-bold" }
const _hoisted_126 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_127 = { class: "d-flex gap-2" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_129 = { class: "indicator-label" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_131 = { class: "indicator-progress" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_133 = ["disabled"]
const _hoisted_134 = { class: "svg-icon svg-icon-2" }
const _hoisted_135 = ["disabled"]
const _hoisted_136 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_138 = ["disabled"]
const _hoisted_139 = { class: "svg-icon svg-icon-2" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = { class: "indicator-label" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_143 = { class: "indicator-progress" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_145 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_146 = { class: "card-header flex-max-sm-column max-sm-align-items-start" }
const _hoisted_147 = { class: "card-title align-items-start flex-column" }
const _hoisted_148 = ["title"]
const _hoisted_149 = { class: "card-toolbar" }
const _hoisted_150 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_151 = { class: "text-gray-400 ms-2" }
const _hoisted_152 = { class: "card-body p-9" }
const _hoisted_153 = { class: "row" }
const _hoisted_154 = { class: "col-md-6 form-group mb-7" }
const _hoisted_155 = { class: "form-label fw-bold required" }
const _hoisted_156 = { class: "col-md-6 form-group mb-7" }
const _hoisted_157 = { class: "form-label fw-bold required" }
const _hoisted_158 = { class: "col-md-6 form-group mb-7" }
const _hoisted_159 = { class: "form-label fw-bold" }
const _hoisted_160 = { class: "col-md-6 form-group mb-7" }
const _hoisted_161 = { class: "form-label fw-bold" }
const _hoisted_162 = { class: "col-md-6 form-group mb-7" }
const _hoisted_163 = { class: "form-label fw-bold" }
const _hoisted_164 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_165 = { class: "form-label fw-bold" }
const _hoisted_166 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_167 = { class: "form-label fw-bold required" }
const _hoisted_168 = { class: "row" }
const _hoisted_169 = { class: "col-md-6 form-group mb-7" }
const _hoisted_170 = { class: "form-label fw-bold" }
const _hoisted_171 = { class: "col-md-6 form-group mb-7" }
const _hoisted_172 = { class: "form-label fw-bold" }
const _hoisted_173 = { class: "col-md-6 form-group mb-7" }
const _hoisted_174 = { class: "form-label fw-bold" }
const _hoisted_175 = { class: "col-md-6 form-group mb-7" }
const _hoisted_176 = { class: "form-label fw-bold" }
const _hoisted_177 = { class: "col-md-12 form-group mb-7" }
const _hoisted_178 = { class: "form-label fw-bold" }
const _hoisted_179 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_180 = { class: "d-flex gap-2" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_182 = { class: "indicator-label" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_184 = { class: "indicator-progress" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_186 = ["disabled"]
const _hoisted_187 = { class: "svg-icon svg-icon-2" }
const _hoisted_188 = ["disabled"]
const _hoisted_189 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_191 = ["disabled"]
const _hoisted_192 = { class: "svg-icon svg-icon-2" }
const _hoisted_193 = ["disabled"]
const _hoisted_194 = { class: "indicator-label" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_196 = { class: "indicator-progress" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_198 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_199 = { class: "card-header flex-max-sm-column max-sm-align-items-start" }
const _hoisted_200 = { class: "card-title align-items-start flex-column" }
const _hoisted_201 = ["title"]
const _hoisted_202 = { class: "card-toolbar" }
const _hoisted_203 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_204 = { class: "text-gray-400 ms-2" }
const _hoisted_205 = { class: "card-body p-9" }
const _hoisted_206 = { class: "row" }
const _hoisted_207 = { class: "col-md-6 form-group mb-7" }
const _hoisted_208 = { class: "form-label fw-bold required" }
const _hoisted_209 = { class: "col-md-6 form-group mb-7" }
const _hoisted_210 = { class: "form-label fw-bold required" }
const _hoisted_211 = { class: "col-md-6 form-group mb-7" }
const _hoisted_212 = { class: "form-label fw-bold required" }
const _hoisted_213 = { class: "col-md-6 form-group mb-7" }
const _hoisted_214 = { class: "form-label fw-bold required" }
const _hoisted_215 = { class: "col-md-12 form-group mb-7" }
const _hoisted_216 = { class: "form-label fw-bold" }
const _hoisted_217 = { class: "col-md-6 form-group mb-7" }
const _hoisted_218 = { class: "form-label fw-bold" }
const _hoisted_219 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_220 = { class: "d-flex gap-2" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_222 = { class: "indicator-label" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_224 = { class: "indicator-progress" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_226 = ["disabled"]
const _hoisted_227 = { class: "svg-icon svg-icon-2" }
const _hoisted_228 = ["disabled"]
const _hoisted_229 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_231 = ["disabled"]
const _hoisted_232 = { class: "svg-icon svg-icon-2" }
const _hoisted_233 = ["disabled"]
const _hoisted_234 = { class: "indicator-label" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_236 = { class: "indicator-progress" }
const _hoisted_237 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_238 = {
  key: 2,
  class: "card"
}
const _hoisted_239 = { class: "card-header" }
const _hoisted_240 = { class: "card-title align-items-start flex-column" }
const _hoisted_241 = ["title"]
const _hoisted_242 = { class: "card-toolbar" }
const _hoisted_243 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_244 = { class: "text-gray-400 ms-2" }
const _hoisted_245 = { class: "card-body p-9" }
const _hoisted_246 = { class: "row d-flex align-items-center" }
const _hoisted_247 = { class: "col-md-6 form-group mb-7" }
const _hoisted_248 = { class: "form-label fw-bold" }
const _hoisted_249 = { class: "card-footer d-flex flex-column gap-5 py-6 px-9" }
const _hoisted_250 = { class: "d-flex gap-2" }
const _hoisted_251 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_252 = { class: "indicator-label" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_254 = { class: "indicator-progress" }
const _hoisted_255 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_256 = ["disabled"]
const _hoisted_257 = { class: "svg-icon svg-icon-2" }
const _hoisted_258 = ["disabled"]
const _hoisted_259 = { class: "card-footer d-flex flex-wrap justify-content-end flex-max-sm-column max-sm-align-items-end gap-2 py-6 px-9" }
const _hoisted_260 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_261 = ["disabled"]
const _hoisted_262 = { class: "svg-icon svg-icon-2" }
const _hoisted_263 = ["disabled"]
const _hoisted_264 = { class: "indicator-label" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_266 = { class: "indicator-progress" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_268 = { class: "col-xl-3 mt-0 mt-xl-10" }
const _hoisted_269 = {
  key: 0,
  class: "card shadow-sm mb-5 mb-xl-10"
}
const _hoisted_270 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_customer_information"
}
const _hoisted_271 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_272 = { class: "card-toolbar rotate-180" }
const _hoisted_273 = { class: "svg-icon svg-icon-1" }
const _hoisted_274 = {
  id: "kt_docs_card_customer_information",
  class: "collapse show"
}
const _hoisted_275 = { class: "card-body" }
const _hoisted_276 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_277 = { key: 0 }
const _hoisted_278 = { class: "fw-bold" }
const _hoisted_279 = { class: "text-gray-600" }
const _hoisted_280 = { key: 1 }
const _hoisted_281 = { class: "fw-bold" }
const _hoisted_282 = { class: "text-gray-600" }
const _hoisted_283 = { key: 2 }
const _hoisted_284 = { class: "fw-bold" }
const _hoisted_285 = { class: "text-gray-600" }
const _hoisted_286 = { key: 3 }
const _hoisted_287 = { class: "fw-bold" }
const _hoisted_288 = { class: "text-gray-600" }
const _hoisted_289 = ["href"]
const _hoisted_290 = { class: "svg-icon svg-icon-2 svg-icon-primary me-2" }
const _hoisted_291 = {
  key: 1,
  class: "card shadow-sm mb-5 mb-xl-10"
}
const _hoisted_292 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_customer_reference"
}
const _hoisted_293 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_294 = { class: "card-toolbar rotate-180" }
const _hoisted_295 = { class: "svg-icon svg-icon-1" }
const _hoisted_296 = {
  id: "kt_docs_card_customer_reference",
  class: "collapse show"
}
const _hoisted_297 = { class: "card-body" }
const _hoisted_298 = ["disabled"]
const _hoisted_299 = { class: "svg-icon svg-icon-2" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_301 = { class: "d-flex flex-nowrap align-items-center" }
const _hoisted_302 = {
  key: 0,
  class: "flex-1 d-flex align-items-center"
}
const _hoisted_303 = {
  key: 1,
  class: "el-upload-list__item-name flex-1"
}
const _hoisted_304 = ["onClick"]
const _hoisted_305 = {
  key: 0,
  class: "el-upload__tip"
}
const _hoisted_306 = ["disabled"]
const _hoisted_307 = { class: "svg-icon svg-icon-2" }
const _hoisted_308 = ["disabled"]
const _hoisted_309 = { class: "svg-icon svg-icon-2" }
const _hoisted_310 = ["disabled"]
const _hoisted_311 = { class: "svg-icon svg-icon-2" }
const _hoisted_312 = { class: "el-upload__tip" }
const _hoisted_313 = { class: "card shadow-sm mb-5 mb-xl-10" }
const _hoisted_314 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_articles"
}
const _hoisted_315 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_316 = { class: "card-toolbar rotate-180" }
const _hoisted_317 = { class: "svg-icon svg-icon-1" }
const _hoisted_318 = {
  id: "kt_docs_card_articles",
  class: "collapse show"
}
const _hoisted_319 = { class: "card-body" }
const _hoisted_320 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_321 = { class: "fw-bold" }
const _hoisted_322 = { class: "text-gray-600" }
const _hoisted_323 = { key: 0 }
const _hoisted_324 = { class: "fw-bold" }
const _hoisted_325 = { class: "text-gray-600" }
const _hoisted_326 = { key: 1 }
const _hoisted_327 = { class: "fw-bold" }
const _hoisted_328 = { class: "text-gray-600" }
const _hoisted_329 = { class: "card shadow-sm mb-5 mb-xl-10" }
const _hoisted_330 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_shipping_address"
}
const _hoisted_331 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_332 = { class: "card-toolbar rotate-180" }
const _hoisted_333 = { class: "svg-icon svg-icon-1" }
const _hoisted_334 = {
  id: "kt_docs_card_shipping_address",
  class: "collapse show"
}
const _hoisted_335 = { class: "card-body" }
const _hoisted_336 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_337 = { key: 0 }
const _hoisted_338 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, null, -1)
const _hoisted_339 = { class: "text-gray-600" }
const _hoisted_340 = {
  key: 0,
  class: "pb-5 fs-6"
}
const _hoisted_341 = { class: "fw-bold mt-5" }
const _hoisted_342 = { class: "text-gray-600" }
const _hoisted_343 = { class: "fw-bold mt-5" }
const _hoisted_344 = { class: "text-gray-600" }
const _hoisted_345 = { class: "fw-bold mt-5" }
const _hoisted_346 = { class: "text-gray-600" }
const _hoisted_347 = { class: "fw-bold mt-5" }
const _hoisted_348 = { class: "text-gray-600" }
const _hoisted_349 = { class: "fw-bold mt-5" }
const _hoisted_350 = { class: "text-gray-600" }
const _hoisted_351 = { class: "fw-bold mt-5" }
const _hoisted_352 = { class: "text-gray-600" }
const _hoisted_353 = { class: "fw-bold mt-5" }
const _hoisted_354 = { class: "text-gray-600" }
const _hoisted_355 = { class: "fw-bold mt-5" }
const _hoisted_356 = { class: "text-gray-600" }
const _hoisted_357 = {
  key: 2,
  class: "card shadow-sm mb-5 mb-xl-10"
}
const _hoisted_358 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_payment_information"
}
const _hoisted_359 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_360 = { class: "card-toolbar rotate-180" }
const _hoisted_361 = { class: "svg-icon svg-icon-1" }
const _hoisted_362 = {
  id: "kt_docs_card_payment_information",
  class: "collapse show"
}
const _hoisted_363 = { class: "card-body" }
const _hoisted_364 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_365 = { key: 0 }
const _hoisted_366 = { class: "fw-bold" }
const _hoisted_367 = { class: "text-gray-600" }
const _hoisted_368 = { key: 1 }
const _hoisted_369 = { class: "fw-bold" }
const _hoisted_370 = { class: "text-gray-600" }
const _hoisted_371 = { key: 2 }
const _hoisted_372 = { class: "fw-bold" }
const _hoisted_373 = { class: "text-gray-600" }
const _hoisted_374 = { key: 3 }
const _hoisted_375 = { class: "fw-bold" }
const _hoisted_376 = { class: "text-gray-600" }
const _hoisted_377 = {
  key: 3,
  class: "card shadow-sm mb-5 mb-xl-10"
}
const _hoisted_378 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_proof_of_payment"
}
const _hoisted_379 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_380 = { class: "card-toolbar rotate-180" }
const _hoisted_381 = { class: "svg-icon svg-icon-1" }
const _hoisted_382 = {
  id: "kt_docs_card_proof_of_payment",
  class: "collapse show"
}
const _hoisted_383 = { class: "card-body" }
const _hoisted_384 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_385 = { class: "fw-bold" }
const _hoisted_386 = { class: "text-gray-600" }
const _hoisted_387 = { class: "fw-bold" }
const _hoisted_388 = { class: "text-gray-600" }
const _hoisted_389 = { class: "row g-3 g-lg-6" }
const _hoisted_390 = ["onClick"]
const _hoisted_391 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_validation_rejection_modal = _resolveComponent("validation-rejection-modal")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form, {
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.submitSalesOrder()), ["prevent"])),
                rules: _ctx.salesOrderRules,
                model: _ctx.formData,
                ref: "formSalesOrderRef"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h3", null, [
                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.distribution")), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            (_ctx.formData.distribution.verified_status !== 1 ||
                              _ctx.formData.priority_management.verified_status !==
                                1),
                          'svg-icon-success':
                            _ctx.formData.distribution.verified_status === 1,
                        }]),
                            title: 
                          _ctx.formData.distribution.verified_status === 1 &&
                          _ctx.formData.priority_management.verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                          }, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                          ], 10, _hoisted_9)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_el_switch, {
                            modelValue: 
                          _ctx.formData.priority_management.high_priority_order
                        ,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
                          _ctx.formData.priority_management.high_priority_order
                        ) = $event)),
                            "active-value": _ctx.options.CommonSwtich.Active,
                            "inactive-value": _ctx.options.CommonSwtich.InActive
                          }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t("salesOrder.priorityManagement")), 1)
                        ])
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("salesOrder.distributionManager")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.sales_manager" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                ref: "selectSalesManager",
                                onFocus: _ctx.cancelReadonly,
                                "onHook:mounted": _ctx.cancelReadonly,
                                onVisibleChange: _ctx.cancelReadonly,
                                teleported: false,
                                modelValue: _ctx.formData.distribution.sales_manager,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.distribution.sales_manager) = $event)),
                                filterable: "",
                                clearable: "",
                                "remote-show-suffix": "",
                                remote: "",
                                placeholder: _ctx.t('common.plsEnter'),
                                "remote-method": _ctx.searchSalesItems,
                                loading: _ctx.options.sales_managerLoading
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.sales_manager, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("salesOrder.distributionChannel")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.distribution_channel" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.distribution.distribution_channel,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.distribution.distribution_channel) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_channel, (group) => {
                                    return (_openBlock(), _createBlock(_component_el_option_group, {
                                      key: group.label,
                                      label: group.label
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("salesOrder.externalOrderNumber")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.external_order_number" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.distribution.external_order_number,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.distribution.external_order_number) = $event)),
                                type: "text",
                                placeholder: _ctx.t('common.plsEnter'),
                                clearable: ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("salesOrder.influencerMbSegmentation")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.mb_segmentation" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.distribution.mb_segmentation,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.distribution.mb_segmentation) = $event)),
                                clearable: "",
                                multiple: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_segmentation, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("salesOrder.profitMode")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.distribution_model" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.distribution.distribution_model,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.distribution.distribution_model) = $event)),
                                clearable: "",
                                style: {"width":"100%"},
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_model, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("salesOrder.overallNotice")), 1),
                          _createVNode(_component_el_form_item, { prop: "distribution.overall_notice" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.distribution.overall_notice,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.distribution.overall_notice) = $event)),
                                type: "textarea",
                                placeholder: _ctx.t('common.plsEnter'),
                                clearable: ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrder.distributionPriority")), 1),
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("salesOrder.priorityHandling")), 1),
                            _createVNode(_component_el_form_item, { prop: "priority_management.priority_handling" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: 
                              _ctx.formData.priority_management.priority_handling
                            ,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                              _ctx.formData.priority_management.priority_handling
                            ) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_handling, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("salesOrder.priorityLevel")), 1),
                            _createVNode(_component_el_form_item, { prop: "priority_management.priority_level" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: 
                              _ctx.formData.priority_management.priority_level
                            ,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                              _ctx.formData.priority_management.priority_level
                            ) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.priority_level, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("salesOrder.exceptionRiskLevel")), 1),
                            _createVNode(_component_el_form_item, { prop: "priority_management.exception_risk_level" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: 
                              _ctx.formData.priority_management.exception_risk_level
                            ,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                              _ctx.formData.priority_management.exception_risk_level
                            ) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.exception_risk_level, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("salesOrder.deliveryDateAdjustment")), 1),
                            _createVNode(_component_el_form_item, { prop: "priority_management.prioritised_close_date" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: 
                              _ctx.formData.priority_management
                                .prioritised_close_date
                            ,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((
                              _ctx.formData.priority_management
                                .prioritised_close_date
                            ) = $event)),
                                  type: "date",
                                  placeholder: _ctx.t('common.pickDate'),
                                  style: {"width":"100%"},
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (
                              _ctx.commonChangeDefaultDate(
                                $event,
                                _ctx.formData,
                                'priority_management',
                                'prioritised_close_date'
                              )
                            )),
                                  teleported: false
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("salesOrder.priorityNotice")), 1),
                            _createVNode(_component_el_form_item, { prop: "priority_management.priority_notice" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: 
                              _ctx.formData.priority_management.priority_notice
                            ,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                              _ctx.formData.priority_management.priority_notice
                            ) = $event)),
                                  type: "textarea",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 512), [
                        [_vShow, 
                      _ctx.formData.priority_management.high_priority_order ===
                      _ctx.options.CommonSwtich.Active
                    ]
                      ])
                    ])), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode(_component_window_resize, null, {
                      sm: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-secondary flex-1",
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                            }, [
                              _hoisted_41,
                              _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                            ]),
                            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "submit",
                                  ref: _ctx.submitButton,
                                  class: "btn btn-primary flex-1"
                                }, [
                                  _createElementVNode("span", _hoisted_42, [
                                    _hoisted_43,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_44, [
                                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                    _hoisted_45
                                  ])
                                ], 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                            default: _withCtx(() => [
                              (0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-danger w-100",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_validation_rejection",
                                    disabled: _ctx.loading,
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'distribution',
                              _ctx.formData.distribution.verified_notice
                            )
                          ))
                                  }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_46))
                                : _createCommentVNode("", true),
                              (
                            _ctx.formData.verified_date === '' &&
                            (_ctx.formData.distribution.verified_status !== 1 ||
                              _ctx.formData.priority_management.verified_status !==
                                1)
                          )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    ref: "verifyButton",
                                    type: "button",
                                    class: "btn btn-success w-100",
                                    disabled: _ctx.loading,
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.verifyOrder('distribution')))
                                  }, [
                                    _createElementVNode("span", _hoisted_48, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                    ]),
                                    _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                  ], 8, _hoisted_47))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      lg: _withCtx(() => [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                          }, [
                            _hoisted_50,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                          ]),
                          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                            default: _withCtx(() => [
                              (
                            _ctx.formData.verified_date === '' &&
                            (_ctx.formData.distribution.verified_status !== 1 ||
                              _ctx.formData.priority_management.verified_status !==
                                1)
                          )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    ref: "verifyButton",
                                    type: "button",
                                    class: "btn btn-success",
                                    disabled: _ctx.loading,
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.verifyOrder('distribution')))
                                  }, [
                                    _createElementVNode("span", _hoisted_52, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                    ]),
                                    _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                  ], 8, _hoisted_51))
                                : _createCommentVNode("", true),
                              (0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-danger",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_validation_rejection",
                                    disabled: _ctx.loading,
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'distribution',
                              _ctx.formData.distribution.verified_notice
                            )
                          ))
                                  }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_53))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "submit",
                                ref: _ctx.submitButton,
                                class: "btn btn-primary"
                              }, [
                                _createElementVNode("span", _hoisted_54, [
                                  _hoisted_55,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                ]),
                                _createElementVNode("span", _hoisted_56, [
                                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                  _hoisted_57
                                ])
                              ], 512)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.submitPimOrder()), ["prevent"])),
                rules: _ctx.pimOrderRules,
                model: _ctx.formData,
                ref: "formPimOrderRef"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrder.pim")), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.pim.verified_status !== 1,
                          'svg-icon-success':
                            _ctx.formData.pim.verified_status === 1,
                        }]),
                                title: 
                          _ctx.formData.pim.verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                              ], 10, _hoisted_61)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_el_switch, {
                                modelValue: _ctx.formData.pim.additional_pim_service,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.pim.additional_pim_service) = $event)),
                                "active-value": _ctx.options.CommonSwtich.Active,
                                "inactive-value": _ctx.options.CommonSwtich.InActive
                              }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.t("salesOrder.additionalPimService")), 1)
                            ])
                          ])
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.t("salesOrderOverview.pimManager")), 1),
                              _createVNode(_component_el_form_item, { prop: "pim.pim_manager" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    class: "w-100",
                                    ref: "selectPimManager",
                                    onFocus: _ctx.cancelReadonly,
                                    "onHook:mounted": _ctx.cancelReadonly,
                                    onVisibleChange: _ctx.cancelReadonly,
                                    teleported: false,
                                    modelValue: _ctx.formData.pim.pim_manager,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.pim.pim_manager) = $event)),
                                    filterable: "",
                                    clearable: "",
                                    "remote-show-suffix": "",
                                    remote: "",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    "remote-method": _ctx.searchPimItems,
                                    loading: _ctx.options.pim_managerLoading
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.pim_manager, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.t("salesOrder.mbOrderType")), 1),
                              _createVNode(_component_el_form_item, { prop: "pim.mb_order_type" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    class: "w-100",
                                    modelValue: _ctx.formData.pim.mb_order_type,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.pim.mb_order_type) = $event)),
                                    placeholder: _ctx.t('common.plsSelect'),
                                    onChange: _ctx.mbOrderTypeChange
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_order_type, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.formData.pim.mb_order_type === '2')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.t("salesOrder.definiteInventoryType")), 1),
                                  _createVNode(_component_el_form_item, { prop: "pim.definite_inventory_source" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "w-100",
                                        modelValue: _ctx.formData.pim.definite_inventory_source,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.pim.definite_inventory_source) = $event)),
                                        clearable: "",
                                        placeholder: _ctx.t('common.plsSelect')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.definite_inventory_source, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.t("salesOrder.minimumInventoryRequest")), 1),
                              _createVNode(_component_el_form_item, { prop: "pim.minimum_inventory_request" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createVNode(_component_el_input_number, {
                                      class: "text-start w-100",
                                      modelValue: _ctx.formData.pim.minimum_inventory_request,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.pim.minimum_inventory_request) = $event)),
                                      precision: 0,
                                      step: 1,
                                      min: 0,
                                      controls: false
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_76
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.t("salesOrder.packageRequirement")), 1),
                              _createVNode(_component_el_form_item, { prop: "pim.package_requirement" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.pim.package_requirement,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.pim.package_requirement) = $event)),
                                    type: "textarea",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.t("salesOrder.additionalPimNotice")), 1),
                              _createVNode(_component_el_form_item, { prop: "pim.additional_pim_notice" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.pim.additional_pim_notice,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.pim.additional_pim_notice) = $event)),
                                    type: "textarea",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])), [
                          [_vShow, 
                    _ctx.formData.pim.additional_pim_service ===
                    _ctx.options.CommonSwtich.Active
                  ],
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_window_resize, null, {
                          sm: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary flex-1",
                                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                  }, [
                                    _hoisted_83,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                                  ]),
                                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        ref: _ctx.submitButton,
                                        class: "btn btn-primary flex-1"
                                      }, [
                                        _createElementVNode("span", _hoisted_84, [
                                          _hoisted_85,
                                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_86, [
                                          _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                          _hoisted_87
                                        ])
                                      ], 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-danger w-100",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[28] || (_cache[28] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'pim',
                                _ctx.formData.pim.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_88))
                                      : _createCommentVNode("", true),
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.pim.verified_status !== 1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success w-100",
                                          disabled: _ctx.loading,
                                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.verifyOrder('pim')))
                                        }, [
                                          _createElementVNode("span", _hoisted_90, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                        ], 8, _hoisted_89))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.pim.additional_pim_service ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          lg: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-secondary",
                                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                }, [
                                  _hoisted_92,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.pim.verified_status !== 1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success",
                                          disabled: _ctx.loading,
                                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.verifyOrder('pim')))
                                        }, [
                                          _createElementVNode("span", _hoisted_94, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                        ], 8, _hoisted_93))
                                      : _createCommentVNode("", true),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-danger",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[32] || (_cache[32] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'pim',
                                _ctx.formData.pim.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_95))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      ref: _ctx.submitButton,
                                      class: "btn btn-primary"
                                    }, [
                                      _createElementVNode("span", _hoisted_96, [
                                        _hoisted_97,
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_98, [
                                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                        _hoisted_99
                                      ])
                                    ], 512)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.pim.additional_pim_service ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.submitFulfillmentOrder()), ["prevent"])),
                rules: _ctx.fulfillmentOrderRules,
                model: _ctx.formData,
                ref: "formFulfillmentOrderRef"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("h3", null, [
                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.fulfillment")), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.fulfillment.verified_status !== 1,
                          'svg-icon-success':
                            _ctx.formData.fulfillment.verified_status === 1,
                        }]),
                            title: 
                          _ctx.formData.fulfillment.verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                          }, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                          ], 10, _hoisted_103)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _createVNode(_component_el_switch, {
                            modelValue: 
                          _ctx.formData.fulfillment.additional_fulfillment_service
                        ,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((
                          _ctx.formData.fulfillment.additional_fulfillment_service
                        ) = $event)),
                            "active-value": _ctx.options.CommonSwtich.Active,
                            "inactive-value": _ctx.options.CommonSwtich.InActive
                          }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                          _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.t("salesOrder.additionalFulfillmentService")), 1)
                        ])
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.t("salesOrder.fulfillmentManager")), 1),
                          _createVNode(_component_el_form_item, { prop: "fulfillment.fulfillment_manager" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                ref: "selectFulfillmentManager",
                                onFocus: _ctx.cancelReadonly,
                                "onHook:mounted": _ctx.cancelReadonly,
                                onVisibleChange: _ctx.cancelReadonly,
                                teleported: false,
                                modelValue: _ctx.formData.fulfillment.fulfillment_manager,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.fulfillment.fulfillment_manager) = $event)),
                                filterable: "",
                                clearable: "",
                                "remote-show-suffix": "",
                                remote: "",
                                placeholder: _ctx.t('common.plsEnter'),
                                "remote-method": _ctx.searchOrderItems,
                                loading: _ctx.options.fulfillment_managerLoading
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_manager, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.t("salesOrder.mbFulfillmentType")), 1),
                          _createVNode(_component_el_form_item, { prop: "fulfillment.mb_fulfillment_type" }, {
                            default: _withCtx(() => [
                              (_ctx.isHasChildrenTagging)
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 0,
                                    class: "w-100",
                                    modelValue: _ctx.formData.fulfillment.mb_fulfillment_type,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.fulfillment.mb_fulfillment_type) = $event)),
                                    clearable: "",
                                    placeholder: _ctx.t('common.plsSelect')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_fulfillment_type, (group) => {
                                        return (_openBlock(), _createBlock(_component_el_option_group, {
                                          key: group.label,
                                          label: group.label
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"]))
                                : (_openBlock(), _createBlock(_component_el_select, {
                                    key: 1,
                                    class: "w-100",
                                    modelValue: _ctx.formData.fulfillment.mb_fulfillment_type,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.fulfillment.mb_fulfillment_type) = $event)),
                                    clearable: "",
                                    placeholder: _ctx.t('common.plsSelect')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_fulfillment_type, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.t("salesOrder.customerClearanceMode")), 1),
                          _createVNode(_component_el_form_item, { prop: "fulfillment.tax_duties_terms" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.fulfillment.tax_duties_terms,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.fulfillment.tax_duties_terms) = $event)),
                                clearable: "",
                                placeholder: " ",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.tax_duties_terms, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.t("salesOrder.requriedDocuments")), 1),
                            _createVNode(_component_el_form_item, { prop: "fulfillment.required_documents" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.fulfillment.required_documents,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.fulfillment.required_documents) = $event)),
                                  multiple: "",
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.required_documents, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.t("salesOrder.packingService")), 1),
                            _createVNode(_component_el_form_item, { prop: "fulfillment.packaging_service" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.fulfillment.packaging_service,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.fulfillment.packaging_service) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.packaging_service, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.t("salesOrder.shippingMode")), 1),
                            _createVNode(_component_el_form_item, { prop: "fulfillment.partial_shipment" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.fulfillment.partial_shipment,
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.fulfillment.partial_shipment) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.partial_shipment, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.t("salesOrder.completeOrderManually")), 1),
                            _createVNode(_component_el_form_item, { prop: "fulfillment.complete_order_manually" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_switch, {
                                  modelValue: 
                              _ctx.formData.fulfillment.complete_order_manually
                            ,
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((
                              _ctx.formData.fulfillment.complete_order_manually
                            ) = $event)),
                                  "active-value": _ctx.options.CommonSwtich.Active,
                                  "inactive-value": _ctx.options.CommonSwtich.InActive
                                }, null, 8, ["modelValue", "active-value", "inactive-value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.t("salesOrder.addtionalFulfillmentNotice")), 1),
                            _createVNode(_component_el_form_item, { prop: "fulfillment.fulfillment_notice" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.fulfillment.fulfillment_notice,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.fulfillment.fulfillment_notice) = $event)),
                                  type: "textarea",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 512), [
                        [_vShow, 
                      _ctx.formData.fulfillment.additional_fulfillment_service ===
                      _ctx.options.CommonSwtich.Active
                    ]
                      ])
                    ])), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode(_component_window_resize, null, {
                      sm: _withCtx(() => [
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-secondary flex-1",
                              onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                            }, [
                              _hoisted_128,
                              _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                            ]),
                            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "submit",
                                  ref: _ctx.submitButton,
                                  class: "btn btn-primary flex-1"
                                }, [
                                  _createElementVNode("span", _hoisted_129, [
                                    _hoisted_130,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_131, [
                                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                    _hoisted_132
                                  ])
                                ], 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                            default: _withCtx(() => [
                              (
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.fulfillment.verified_status !== 1
                          )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    ref: "verifyButton",
                                    type: "button",
                                    class: "btn btn-success w-100",
                                    disabled: _ctx.loading,
                                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.verifyOrder('fulfillment')))
                                  }, [
                                    _createElementVNode("span", _hoisted_134, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                    ]),
                                    _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                  ], 8, _hoisted_133))
                                : _createCommentVNode("", true),
                              (0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-danger w-100",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_validation_rejection",
                                    disabled: _ctx.loading,
                                    onClick: _cache[46] || (_cache[46] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'fulfillment',
                              _ctx.formData.fulfillment.verified_notice
                            )
                          ))
                                  }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_135))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      lg: _withCtx(() => [
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                          }, [
                            _hoisted_137,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                          ]),
                          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                            default: _withCtx(() => [
                              (
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.fulfillment.verified_status !== 1
                          )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    ref: "verifyButton",
                                    type: "button",
                                    class: "btn btn-success",
                                    disabled: _ctx.loading,
                                    onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.verifyOrder('fulfillment')))
                                  }, [
                                    _createElementVNode("span", _hoisted_139, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                    ]),
                                    _createTextVNode(_toDisplayString(_ctx.t("salesOrder.verify")), 1)
                                  ], 8, _hoisted_138))
                                : _createCommentVNode("", true),
                              (0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-danger",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_validation_rejection",
                                    disabled: _ctx.loading,
                                    onClick: _cache[49] || (_cache[49] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'fulfillment',
                              _ctx.formData.fulfillment.verified_notice
                            )
                          ))
                                  }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_140))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "submit",
                                ref: _ctx.submitButton,
                                class: "btn btn-primary"
                              }, [
                                _createElementVNode("span", _hoisted_141, [
                                  _hoisted_142,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                ]),
                                _createElementVNode("span", _hoisted_143, [
                                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                  _hoisted_144
                                ])
                              ], 512)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[94] || (_cache[94] = _withModifiers(($event: any) => (_ctx.submitSettlementOrder()), ["prevent"])),
                rules: _ctx.settlementOrderRules,
                model: _ctx.formData,
                ref: "formSettlementOrderRef"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlement")), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.settlement_fraud_controlling
                              .verified_status !== 1,
                          'svg-icon-success':
                            _ctx.formData.settlement_fraud_controlling
                              .verified_status === 1,
                        }]),
                                title: 
                          _ctx.formData.settlement_fraud_controlling
                            .verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                              ], 10, _hoisted_148)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_149, [
                            _createElementVNode("div", _hoisted_150, [
                              _createVNode(_component_el_switch, {
                                modelValue: 
                          _ctx.formData.settlement_fraud_controlling
                            .offline_payment_controlling
                        ,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((
                          _ctx.formData.settlement_fraud_controlling
                            .offline_payment_controlling
                        ) = $event)),
                                "active-value": _ctx.options.CommonRequiredSwtich.Requried,
                                "inactive-value": 
                          _ctx.options.CommonRequiredSwtich.NotRequried
                        
                              }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                              _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.t("salesOrder.additionalSettlementService")), 1)
                            ])
                          ])
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_152, [
                          _createElementVNode("div", _hoisted_153, [
                            _createElementVNode("div", _hoisted_154, [
                              _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.t("salesOrder.settlementType")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.settlement_type" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .settlement_type
                          ,
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .settlement_type
                          ) = $event)),
                                    clearable: "",
                                    placeholder: _ctx.t('common.plsSelect'),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.settlement_type, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: index,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_156, [
                              _createElementVNode("label", _hoisted_157, _toDisplayString(_ctx.t("salesOrder.settlementMode")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.settlement_mode" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .settlement_mode
                          ,
                                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .settlement_mode
                          ) = $event)),
                                    clearable: "",
                                    placeholder: _ctx.t('common.plsSelect'),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.settlement_mode, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: index,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_158, [
                              _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.t("salesOrder.depositInAdvance")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.deposit_in_advance" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .deposit_in_advance
                          ,
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .deposit_in_advance
                          ) = $event)),
                                    "active-value": _ctx.options.CommonSwtich.Active,
                                    "inactive-value": _ctx.options.CommonSwtich.InActive
                                  }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_160, [
                              _createElementVNode("label", _hoisted_161, _toDisplayString(_ctx.t("salesOrder.settlementManager")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.offline_payment_controller" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    ref: "selectOfflinePaymentController",
                                    onFocus: _ctx.cancelReadonly,
                                    "onHook:mounted": _ctx.cancelReadonly,
                                    onVisibleChange: _ctx.cancelReadonly,
                                    teleported: false,
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .offline_payment_controller
                          ,
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .offline_payment_controller
                          ) = $event)),
                                    filterable: "",
                                    clearable: "",
                                    "remote-show-suffix": "",
                                    remote: "",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    "remote-method": _ctx.searchPaymentItems,
                                    loading: _ctx.options.offline_payment_controllerLoading
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.offline_payment_controller, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_162, [
                              _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.t("salesOrder.settlementInAdvance")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_tax_refund.settlement_in_advance" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: 
                            _ctx.formData.settlement_tax_refund.settlement_in_advance
                          ,
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((
                            _ctx.formData.settlement_tax_refund.settlement_in_advance
                          ) = $event)),
                                    "active-value": _ctx.options.CommonDropdownSwtich.Yes,
                                    "inactive-value": _ctx.options.CommonDropdownSwtich.No
                                  }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                ]),
                                _: 1
                              })
                            ]),
                            (!_ctx.isDoubleSale)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                  _createElementVNode("label", _hoisted_165, _toDisplayString(_ctx.t("salesOrder.customSettlementDate")), 1),
                                  _createVNode(_component_el_form_item, { prop: "settlement_tax_refund.custom_settlement_date" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_date_picker, {
                                        modelValue: 
                            _ctx.formData.settlement_tax_refund
                              .custom_settlement_date
                          ,
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((
                            _ctx.formData.settlement_tax_refund
                              .custom_settlement_date
                          ) = $event)),
                                        type: "date",
                                        placeholder: _ctx.t('common.pickDate'),
                                        style: {"width":"100%"},
                                        onChange: _cache[58] || (_cache[58] = ($event: any) => (
                            _ctx.commonChangeDefaultDate(
                              $event,
                              _ctx.formData,
                              'settlement_tax_refund',
                              'custom_settlement_date'
                            )
                          )),
                                        teleported: false
                                      }, null, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isDoubleSale)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                  _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.t("salesOrder.businessDate")), 1),
                                  _createVNode(_component_el_form_item, { prop: "settlement_tax_refund.business_date" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_date_picker, {
                                        modelValue: _ctx.formData.settlement_tax_refund.business_date,
                                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.formData.settlement_tax_refund.business_date) = $event)),
                                        type: "date",
                                        placeholder: _ctx.t('common.pickDate'),
                                        style: {"width":"100%"},
                                        teleported: false,
                                        "disabled-date": _ctx.businessDateDisabledDate,
                                        format: "YYYY-MM-DD",
                                        "value-format": "YYYY-MM-DD",
                                        disabled: _ctx.formData.settlement_tax_refund.has_billing
                                      }, null, 8, ["modelValue", "placeholder", "disabled-date", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_168, [
                            _createElementVNode("div", _hoisted_169, [
                              _createElementVNode("label", _hoisted_170, _toDisplayString(_ctx.t("salesOrderOverview.offlinePaymentStatusTrack")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.track_payment_status" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .track_payment_status
                          ,
                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .track_payment_status
                          ) = $event)),
                                    "active-value": _ctx.options.CommonSwtich.Active,
                                    "inactive-value": _ctx.options.CommonSwtich.InActive
                                  }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_171, [
                              _createElementVNode("label", _hoisted_172, _toDisplayString(_ctx.t("salesOrder.applyPaymentDeferral")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.apply_payment_deferral" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .apply_payment_deferral
                          ,
                                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .apply_payment_deferral
                          ) = $event)),
                                    "active-value": _ctx.options.CommonSwtich.Active,
                                    "inactive-value": _ctx.options.CommonSwtich.InActive
                                  }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_173, [
                              _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.t("salesOrder.creditRiskControl")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.credit_risk_control" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .credit_risk_control
                          ,
                                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .credit_risk_control
                          ) = $event)),
                                    clearable: "",
                                    placeholder: _ctx.t('common.plsSelect')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.credit_risk_control, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_175, [
                              _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.t("salesOrderOverview.estPaymentReceivedDate")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.offline_payment_due_date" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    class: "w-100",
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .offline_payment_due_date
                          ,
                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .offline_payment_due_date
                          ) = $event)),
                                    type: "date",
                                    placeholder: _ctx.t('common.pickDate'),
                                    onChange: _cache[64] || (_cache[64] = ($event: any) => (
                            _ctx.commonChangeDefaultDate(
                              $event,
                              _ctx.formData,
                              'settlement_fraud_controlling',
                              'offline_payment_due_date'
                            )
                          )),
                                    teleported: false
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_177, [
                              _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.t("salesOrder.additionalSettlementNotice")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_fraud_controlling.additional_settlement_notice" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                            _ctx.formData.settlement_fraud_controlling
                              .additional_settlement_notice
                          ,
                                    "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((
                            _ctx.formData.settlement_fraud_controlling
                              .additional_settlement_notice
                          ) = $event)),
                                    type: "textarea",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ], 512), [
                            [_vShow, 
                      _ctx.formData.settlement_fraud_controlling
                        .offline_payment_controlling == 1
                    ]
                          ])
                        ])), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_window_resize, null, {
                          sm: _withCtx(() => [
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("div", _hoisted_180, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-secondary flex-1",
                                  onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                }, [
                                  _hoisted_181,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      type: "submit",
                                      ref: _ctx.submitButton,
                                      class: "btn btn-primary flex-1"
                                    }, [
                                      _createElementVNode("span", _hoisted_182, [
                                        _hoisted_183,
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_184, [
                                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                        _hoisted_185
                                      ])
                                    ], 512)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                default: _withCtx(() => [
                                  (
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.settlement_bc_payment.verified_status !== 1
                          )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        ref: "verifyButton",
                                        type: "button",
                                        class: "btn btn-success w-100",
                                        disabled: _ctx.loading,
                                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                      }, [
                                        _createElementVNode("span", _hoisted_187, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                        ]),
                                        _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                      ], 8, _hoisted_186))
                                    : _createCommentVNode("", true),
                                  (0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn btn-dange w-100",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#modal_validation_rejection",
                                        disabled: _ctx.loading,
                                        onClick: _cache[68] || (_cache[68] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'settlement',
                              _ctx.formData.settlement_bc_payment.verified_notice
                            )
                          ))
                                      }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_188))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          lg: _withCtx(() => [
                            _createElementVNode("div", _hoisted_189, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                              }, [
                                _hoisted_190,
                                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                              ]),
                              _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                default: _withCtx(() => [
                                  (
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.settlement_bc_payment.verified_status !== 1
                          )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        ref: "verifyButton",
                                        type: "button",
                                        class: "btn btn-success",
                                        disabled: _ctx.loading,
                                        onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                      }, [
                                        _createElementVNode("span", _hoisted_192, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                        ]),
                                        _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                      ], 8, _hoisted_191))
                                    : _createCommentVNode("", true),
                                  (0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn btn-danger",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#modal_validation_rejection",
                                        disabled: _ctx.loading,
                                        onClick: _cache[71] || (_cache[71] = ($event: any) => (
                            _ctx.validationRejectOrder(
                              'settlement',
                              _ctx.formData.settlement_bc_payment.verified_notice
                            )
                          ))
                                      }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_193))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    type: "submit",
                                    ref: _ctx.submitButton,
                                    class: "btn btn-primary"
                                  }, [
                                    _createElementVNode("span", _hoisted_194, [
                                      _hoisted_195,
                                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                    ]),
                                    _createElementVNode("span", _hoisted_196, [
                                      _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                      _hoisted_197
                                    ])
                                  ], 512)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                        _createElementVNode("div", _hoisted_199, [
                          _createElementVNode("div", _hoisted_200, [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementBcPayment")), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.settlement_bc_payment.verified_status !==
                              1,
                          'svg-icon-success':
                            _ctx.formData.settlement_bc_payment.verified_status ===
                            1,
                        }]),
                                title: 
                          _ctx.formData.settlement_bc_payment.verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                              ], 10, _hoisted_201)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_202, [
                            _createElementVNode("div", _hoisted_203, [
                              _createVNode(_component_el_switch, {
                                modelValue: 
                          _ctx.formData.settlement_bc_payment.bc_custom_clearance
                        ,
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((
                          _ctx.formData.settlement_bc_payment.bc_custom_clearance
                        ) = $event)),
                                "active-value": _ctx.options.CommonSwtich.Active,
                                "inactive-value": _ctx.options.CommonSwtich.InActive
                              }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                              _createElementVNode("span", _hoisted_204, _toDisplayString(_ctx.t("salesOrder.paymentForBCClearance")), 1)
                            ])
                          ])
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_205, [
                          _createElementVNode("div", _hoisted_206, [
                            _createElementVNode("div", _hoisted_207, [
                              _createElementVNode("label", _hoisted_208, _toDisplayString(_ctx.t("salesOrder.payerIdentifier")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_bc_payment.payer_identifier" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                            _ctx.formData.settlement_bc_payment.payer_identifier
                          ,
                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((
                            _ctx.formData.settlement_bc_payment.payer_identifier
                          ) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_209, [
                              _createElementVNode("label", _hoisted_210, _toDisplayString(_ctx.t("salesOrder.payer")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_bc_payment.payer" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.settlement_bc_payment.payer,
                                    "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.formData.settlement_bc_payment.payer) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_211, [
                              _createElementVNode("label", _hoisted_212, _toDisplayString(_ctx.t("salesOrder.payerIdentityCardNo")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_bc_payment.payer_identity_card_no" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                            _ctx.formData.settlement_bc_payment
                              .payer_identity_card_no
                          ,
                                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((
                            _ctx.formData.settlement_bc_payment
                              .payer_identity_card_no
                          ) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_213, [
                              _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.t("salesOrder.payerMobilePhone")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_bc_payment.payer_mobile_phone" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                            _ctx.formData.settlement_bc_payment.payer_mobile_phone
                          ,
                                    "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((
                            _ctx.formData.settlement_bc_payment.payer_mobile_phone
                          ) = $event)),
                                    modelModifiers: { number: true },
                                    type: "number",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    class: "input-with-select",
                                    clearable: ""
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.mobile_country_code,
                                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.mobile_country_code) = $event)),
                                        style: {"width":"110px"},
                                        autocomplete: "off",
                                        disabled: "",
                                        placeholder: " "
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: _ctx.t('common.mobileCountryCodeChina'),
                                            value: "+86"
                                          }, null, 8, ["label"]),
                                          _createVNode(_component_el_option, {
                                            label: _ctx.t('common.mobileCountryCodeGermany'),
                                            value: "+49"
                                          }, null, 8, ["label"])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_215, [
                              _createElementVNode("label", _hoisted_216, _toDisplayString(_ctx.t("salesOrder.mbAnnualLimitVerification")), 1),
                              _createVNode(_component_el_form_item, {
                                prop: "settlement_bc_payment.mb_annual_limit_verification",
                                class: "form-item-status"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: 
                            _ctx.formData.settlement_bc_payment
                              .mb_annual_limit_verification
                          ,
                                    "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((
                            _ctx.formData.settlement_bc_payment
                              .mb_annual_limit_verification
                          ) = $event)),
                                    size: "mini"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.mb_annual_limit_verification, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_radio, {
                                          key: item.value,
                                          label: item.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_217, [
                              _createElementVNode("label", _hoisted_218, _toDisplayString(_ctx.t("salesOrder.customLimitVerification")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_bc_payment.custom_limit_verification" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: 
                            _ctx.formData.settlement_bc_payment
                              .custom_limit_verification
                          ,
                                    "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((
                            _ctx.formData.settlement_bc_payment
                              .custom_limit_verification
                          ) = $event)),
                                    "active-value": _ctx.options.CommonSwtich.Active,
                                    "inactive-value": _ctx.options.CommonSwtich.InActive
                                  }, null, 8, ["modelValue", "active-value", "inactive-value"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])), [
                          [_vShow, 
                    _ctx.formData.settlement_bc_payment.bc_custom_clearance ===
                    _ctx.options.CommonSwtich.Active
                  ],
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_window_resize, null, {
                          sm: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_219, [
                                _createElementVNode("div", _hoisted_220, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary flex-1",
                                    onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                  }, [
                                    _hoisted_221,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                                  ]),
                                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        ref: _ctx.submitButton,
                                        class: "btn btn-primary flex-1"
                                      }, [
                                        _createElementVNode("span", _hoisted_222, [
                                          _hoisted_223,
                                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_224, [
                                          _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                          _hoisted_225
                                        ])
                                      ], 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.settlement_bc_payment.verified_status !==
                                1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success w-100",
                                          disabled: _ctx.loading,
                                          onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                        }, [
                                          _createElementVNode("span", _hoisted_227, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                        ], 8, _hoisted_226))
                                      : _createCommentVNode("", true),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-danger w-100",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[82] || (_cache[82] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'settlement',
                                _ctx.formData.settlement_bc_payment.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_228))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.settlement_bc_payment.bc_custom_clearance ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          lg: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_229, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-secondary",
                                  onClick: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                }, [
                                  _hoisted_230,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.settlement_bc_payment.verified_status !==
                                1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success",
                                          disabled: _ctx.loading,
                                          onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                        }, [
                                          _createElementVNode("span", _hoisted_232, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                        ], 8, _hoisted_231))
                                      : _createCommentVNode("", true),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-danger",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[85] || (_cache[85] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'settlement',
                                _ctx.formData.settlement_bc_payment.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_233))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      ref: _ctx.submitButton,
                                      class: "btn btn-primary"
                                    }, [
                                      _createElementVNode("span", _hoisted_234, [
                                        _hoisted_235,
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_236, [
                                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                        _hoisted_237
                                      ])
                                    ], 512)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.settlement_bc_payment.bc_custom_clearance ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                        _createElementVNode("div", _hoisted_239, [
                          _createElementVNode("div", _hoisted_240, [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementTaxRefund")), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["svg-icon svg-icon-2 ms-2", {
                          'svg-icon-warning':
                            _ctx.formData.verified_date === '' &&
                            _ctx.formData.settlement_tax_refund.verified_status !==
                              1,
                          'svg-icon-success':
                            _ctx.formData.settlement_tax_refund.verified_status ===
                            1,
                        }]),
                                title: 
                          _ctx.formData.settlement_tax_refund.verified_status === 1
                            ? _ctx.t('salesOrder.statusVerified')
                            : _ctx.t('salesOrderOverview.pendingApproval')
                        
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                              ], 10, _hoisted_241)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_242, [
                            _createElementVNode("div", _hoisted_243, [
                              _createVNode(_component_el_switch, {
                                modelValue: 
                          _ctx.formData.settlement_tax_refund
                            .additional_tax_refund_service
                        ,
                                "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((
                          _ctx.formData.settlement_tax_refund
                            .additional_tax_refund_service
                        ) = $event)),
                                "active-value": _ctx.options.CommonSwtich.Active,
                                "inactive-value": _ctx.options.CommonSwtich.InActive
                              }, null, 8, ["modelValue", "active-value", "inactive-value"]),
                              _createElementVNode("span", _hoisted_244, _toDisplayString(_ctx.t("salesOrder.additionalTaxRefundService")), 1)
                            ])
                          ])
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_245, [
                          _createElementVNode("div", _hoisted_246, [
                            _createElementVNode("div", _hoisted_247, [
                              _createElementVNode("label", _hoisted_248, _toDisplayString(_ctx.t("salesOrder.taxRefundNumber")), 1),
                              _createVNode(_component_el_form_item, { prop: "settlement_tax_refund.tax_refund_number" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: 
                            _ctx.formData.settlement_tax_refund.tax_refund_number
                          ,
                                    "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((
                            _ctx.formData.settlement_tax_refund.tax_refund_number
                          ) = $event)),
                                    modelModifiers: { number: true },
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])), [
                          [_vShow, 
                    _ctx.formData.settlement_tax_refund
                      .additional_tax_refund_service ===
                    _ctx.options.CommonSwtich.Active
                  ],
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_window_resize, null, {
                          sm: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_249, [
                                _createElementVNode("div", _hoisted_250, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary flex-1",
                                    onClick: _cache[88] || (_cache[88] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                  }, [
                                    _hoisted_251,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                                  ]),
                                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        ref: _ctx.submitButton,
                                        class: "btn btn-primary flex-1"
                                      }, [
                                        _createElementVNode("span", _hoisted_252, [
                                          _hoisted_253,
                                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_254, [
                                          _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                          _hoisted_255
                                        ])
                                      ], 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.settlement_bc_payment.verified_status !==
                                1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success w-100",
                                          disabled: _ctx.loading,
                                          onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                        }, [
                                          _createElementVNode("span", _hoisted_257, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                        ], 8, _hoisted_256))
                                      : _createCommentVNode("", true),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-danger w-100",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[90] || (_cache[90] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'settlement',
                                _ctx.formData.settlement_bc_payment.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_258))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.settlement_tax_refund
                          .additional_tax_refund_service ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          lg: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_259, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-secondary",
                                  onClick: _cache[91] || (_cache[91] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                                }, [
                                  _hoisted_260,
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                                ]),
                                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                  default: _withCtx(() => [
                                    (
                              _ctx.formData.verified_date === '' &&
                              _ctx.formData.settlement_bc_payment.verified_status !==
                                1
                            )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          ref: "verifyButton",
                                          type: "button",
                                          class: "btn btn-success",
                                          disabled: _ctx.loading,
                                          onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.verifyOrder('settlement')))
                                        }, [
                                          _createElementVNode("span", _hoisted_262, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil025.svg" })
                                          ]),
                                          _createTextVNode(_toDisplayString(_ctx.t("salesOrder.settlementVerify")), 1)
                                        ], 8, _hoisted_261))
                                      : _createCommentVNode("", true),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-danger",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#modal_validation_rejection",
                                          disabled: _ctx.loading,
                                          onClick: _cache[93] || (_cache[93] = ($event: any) => (
                              _ctx.validationRejectOrder(
                                'settlement',
                                _ctx.formData.settlement_bc_payment.verified_notice
                              )
                            ))
                                        }, _toDisplayString(_ctx.t("salesOrder.reject")), 9, _hoisted_263))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      ref: _ctx.submitButton,
                                      class: "btn btn-primary"
                                    }, [
                                      _createElementVNode("span", _hoisted_264, [
                                        _hoisted_265,
                                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_266, [
                                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                        _hoisted_267
                                      ])
                                    ], 512)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, 
                        _ctx.formData.settlement_tax_refund
                          .additional_tax_refund_service ===
                        _ctx.options.CommonSwtich.Active
                      ]
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_268, [
          (!_ctx.isAuditView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_269, [
                _createElementVNode("div", _hoisted_270, [
                  _createElementVNode("div", _hoisted_271, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.t("salesOrder.customerInformation")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_272, [
                    _createElementVNode("span", _hoisted_273, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_274, [
                  _createElementVNode("div", _hoisted_275, [
                    _createElementVNode("div", _hoisted_276, [
                      (_ctx.formData.distribution.influence_account_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                            _createElementVNode("div", _hoisted_278, _toDisplayString(_ctx.t("salesOrder.influencerAccountId")), 1),
                            _createElementVNode("div", _hoisted_279, _toDisplayString(_ctx.formData.distribution.influence_account_id), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.distribution.influence_order_type)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                            _createElementVNode("div", _hoisted_281, _toDisplayString(_ctx.t("salesOrder.influencerOrderType")), 1),
                            _createElementVNode("div", _hoisted_282, _toDisplayString(_ctx.options.influenceOrderTypeMap.get(
                        _ctx.formData.distribution.influence_order_type
                      )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.sales_order_extended_distribution
                      .mb_segmentation.length > 0
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                            _createElementVNode("div", _hoisted_284, _toDisplayString(_ctx.t("salesOrder.influencerMbSegmentation")), 1),
                            _createElementVNode("div", _hoisted_285, _toDisplayString(String(
                        _ctx.salesOrderOverviewData.sales_order_extended_distribution
                          .mb_segmentation
                      )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.sales_order_extended_distribution
                      .rfm_group_trend
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_286, [
                            _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.t("salesOrderOverview.rfmGroupTrend")), 1),
                            _createElementVNode("div", _hoisted_288, _toDisplayString(_ctx.salesOrderOverviewData.sales_order_extended_distribution
                        .__show.rfm_group_trend), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.distribution.influence_account_id)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 4,
                            href: 
                    _ctx.commonGoToPath(
                      '/influencer-platform/influencer-accounts/' +
                        (parseInt(_ctx.formData.distribution.influence_account_id) -
                          3000000) +
                        '/information',
                      'Distribution'
                    )
                  ,
                            class: "text-primary mb-1",
                            onClick: _cache[95] || (_cache[95] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("span", _hoisted_290, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com012.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.orderProgressionViewDetails")), 1)
                          ], 8, _hoisted_289))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAuditView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
                _createElementVNode("div", _hoisted_292, [
                  _createElementVNode("div", _hoisted_293, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.t("salesOrder.customerReference")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_294, [
                    _createElementVNode("span", _hoisted_295, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_296, [
                  _createElementVNode("div", _hoisted_297, [
                    _createVNode(_component_window_resize, null, {
                      sm: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          class: "w-100",
                          ref: "uploadRefs.file_id",
                          accept: ".pdf,.xls,.xlsx,.jpg,.jpeg,.png",
                          "file-list": _ctx.uploadData.file_id,
                          action: _ctx.uploadUrl,
                          data: { order_id: _ctx.id },
                          headers: _ctx.uploadHeaders,
                          disabled: _ctx.uploadDisabled.file_id,
                          limit: 1,
                          "auto-upload": true,
                          "on-progress": 
                      function (e, file, fileList) {
                        return _ctx.handleProgress(e, file, fileList, 'file_id');
                      }
                    ,
                          "on-success": 
                      function (response, file, fileList) {
                        return _ctx.handleSuccess(
                          response,
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.quotation_information
                        );
                      }
                    ,
                          "on-error": 
                      function (err, file, fileList) {
                        return _ctx.handleError(err, file, fileList, 'file_id');
                      }
                    ,
                          "on-remove": 
                      function (file, fileList) {
                        return _ctx.handleRemove(
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.quotation_information,
                          _ctx.uploadData,
                          _ctx.removeFlag
                        );
                      }
                    ,
                          "on-exceed": 
                      function (files, fileList) {
                        return _ctx.handleExceed(files, fileList, 'file_id');
                      }
                    ,
                          "before-upload": _ctx.handleBeforeUpload
                        }, {
                          trigger: _withCtx(() => [
                            _createVNode(_component_permission_common, { role: {
                          auth: ['update'],
                        } }, {
                              default: _withCtx(() => [
                                (_ctx.uploadData.file_id.length === 0)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-primary w-100",
                                      disabled: _ctx.uploadDisabled.file_id
                                    }, [
                                      _createElementVNode("span", _hoisted_299, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr045.svg" })
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.upload")), 1)
                                    ], 8, _hoisted_298))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          file: _withCtx(({ file }) => [
                            _createElementVNode("div", _hoisted_301, [
                              (file.status === 'uploading')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                    _createVNode(_component_el_progress, {
                                      class: "w-100 position-relative top-0 start-0",
                                      percentage: file.percentage
                                    }, null, 8, ["percentage"])
                                  ]))
                                : (_openBlock(), _createElementBlock("a", _hoisted_303, _toDisplayString(file.name), 1)),
                              _createElementVNode("span", {
                                class: "svg-icon svg-icon-3 svg-icon-2hx svg-icon-danger me-0 ms-2",
                                onClick: _withModifiers(($event: any) => (
                            _ctx.handleRemove(
                              file,
                              _ctx.uploadData.file_id,
                              'file_id',
                              _ctx.formData.quotation_information,
                              _ctx.uploadData,
                              _ctx.removeFlag
                            )
                          ), ["stop"])
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ], 8, _hoisted_304)
                            ])
                          ]),
                          tip: _withCtx(() => [
                            (_ctx.uploadData.file_id.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_305, _toDisplayString(_ctx.t("salesOrder.customerReferenceUploadTip")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _hoisted_300
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                      ]),
                      lg: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          ref: "uploadRefs.file_id",
                          accept: ".pdf,.xls,.xlsx,.jpg,.jpeg,.png",
                          "file-list": _ctx.uploadData.file_id,
                          action: _ctx.uploadUrl,
                          data: { order_id: _ctx.id },
                          headers: _ctx.uploadHeaders,
                          disabled: _ctx.uploadDisabled.file_id,
                          limit: 1,
                          "auto-upload": true,
                          "on-progress": 
                      function (e, file, fileList) {
                        return _ctx.handleProgress(e, file, fileList, 'file_id');
                      }
                    ,
                          "on-success": 
                      function (response, file, fileList) {
                        return _ctx.handleSuccess(
                          response,
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.quotation_information
                        );
                      }
                    ,
                          "on-error": 
                      function (err, file, fileList) {
                        return _ctx.handleError(err, file, fileList, 'file_id');
                      }
                    ,
                          "on-remove": 
                      function (file, fileList) {
                        return _ctx.handleRemove(
                          file,
                          fileList,
                          'file_id',
                          _ctx.formData.quotation_information,
                          _ctx.uploadData,
                          _ctx.removeFlag
                        );
                      }
                    ,
                          "on-exceed": 
                      function (files, fileList) {
                        return _ctx.handleExceed(files, fileList, 'file_id');
                      }
                    ,
                          "before-upload": _ctx.handleBeforeUpload
                        }, {
                          trigger: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-icon btn-primary btn-sm me-2",
                              disabled: _ctx.uploadDisabled.file_id
                            }, [
                              _createElementVNode("span", _hoisted_307, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr045.svg" })
                              ])
                            ], 8, _hoisted_306)), [
                              [_directive_auth, { auth: ['update'] }]
                            ])
                          ]),
                          tip: _withCtx(() => [
                            _createElementVNode("div", _hoisted_312, _toDisplayString(_ctx.t("salesOrder.customerReferenceUploadTip")), 1)
                          ]),
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-icon btn-danger btn-sm me-2",
                              disabled: 
                        _ctx.uploadDisabled.file_id ||
                        _ctx.formData.quotation_information.file_id === 0
                      ,
                              onClick: _cache[96] || (_cache[96] = ($event: any) => (
                        _ctx.handleDeleteUpload(
                          'file_id',
                          _ctx.formData.quotation_information
                        )
                      ))
                            }, [
                              _createElementVNode("span", _hoisted_309, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ])
                            ], 8, _hoisted_308)), [
                              [_directive_auth, { auth: ['update'] }]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-icon btn-success btn-sm me-2",
                              disabled: 
                        _ctx.uploadDisabled.file_id ||
                        _ctx.formData.quotation_information.file_id === 0
                      ,
                              onClick: _cache[97] || (_cache[97] = ($event: any) => (
                        _ctx.handlePreview('file_id', _ctx.formData.quotation_information)
                      ))
                            }, [
                              _createElementVNode("span", _hoisted_311, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
                              ])
                            ], 8, _hoisted_310)), [
                              [_directive_auth, { auth: ['export'] }]
                            ])
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "data", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_313, [
            _createElementVNode("div", _hoisted_314, [
              _createElementVNode("div", _hoisted_315, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("order.articles")), 1)
              ]),
              _createElementVNode("div", _hoisted_316, [
                _createElementVNode("span", _hoisted_317, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_318, [
              _createElementVNode("div", _hoisted_319, [
                _createElementVNode("div", _hoisted_320, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_321, _toDisplayString(_ctx.t("order.skuPcs", [])), 1),
                    _createElementVNode("div", _hoisted_322, _toDisplayString(_ctx.salesOrderOverviewData.ordered_items.length) + " / " + _toDisplayString(_ctx.salesOrderOverviewData.sales_order.total_qty_ordered), 1)
                  ]),
                  (
                    _ctx.salesOrderOverviewData.sales_order_extended_pim
                      .inventory_confirmation_date
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                        _createElementVNode("div", _hoisted_324, _toDisplayString(_ctx.t("salesOrderOverview.inventoryConfirmationDeadline")), 1),
                        _createElementVNode("div", _hoisted_325, _toDisplayString(_ctx.formatDate(
                        _ctx.salesOrderOverviewData.sales_order_extended_pim
                          .inventory_confirmation_date
                      )), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.salesOrderOverviewData.sales_order.merchant_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_326, [
                        _createElementVNode("div", _hoisted_327, _toDisplayString(_ctx.t("salesOrder.inventorySourceMerchant")), 1),
                        _createElementVNode("div", _hoisted_328, _toDisplayString(_ctx.salesOrderOverviewData.sales_order.merchant_name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_329, [
            _createElementVNode("div", _hoisted_330, [
              _createElementVNode("div", _hoisted_331, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t("salesOrder.shippingAddress")), 1)
              ]),
              _createElementVNode("div", _hoisted_332, [
                _createElementVNode("span", _hoisted_333, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_334, [
              _createElementVNode("div", _hoisted_335, [
                _createElementVNode("div", _hoisted_336, [
                  (
                    _ctx.salesOrderOverviewData.shipping_address
                      .recipient_street_address
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_337, [
                        _hoisted_338,
                        _createElementVNode("div", _hoisted_339, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                        .recipient_street_address), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                      (_ctx.salesOrderOverviewData.shipping_address.recipient_name)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_341, _toDisplayString(_ctx.t("salesOrder.recipientName")), 1),
                            _createElementVNode("div", _hoisted_342, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address.recipient_name), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.shipping_address.recipient_mobile_no
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_343, _toDisplayString(_ctx.t("salesOrder.recipientMobileNo")), 1),
                            _createElementVNode("div", _hoisted_344, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                        .recipient_telephone_code) + " " + _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                        .recipient_mobile_no), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.shipping_address
                      .recipient_street_address
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_345, _toDisplayString(_ctx.t("salesOrder.recipientStreetAddress")), 1),
                            _createElementVNode("div", _hoisted_346, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                        .recipient_street_address), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.shipping_address
                      .recipient_postal_code
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", _hoisted_347, _toDisplayString(_ctx.t("salesOrder.recipientPostalCode")), 1),
                            _createElementVNode("div", _hoisted_348, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                        .recipient_postal_code), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.salesOrderOverviewData.shipping_address.recipient_city)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", _hoisted_349, _toDisplayString(_ctx.t("salesOrder.recipientCity")), 1),
                            _createElementVNode("div", _hoisted_350, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address.recipient_city), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.shipping_address.recipient_province
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createElementVNode("div", _hoisted_351, _toDisplayString(_ctx.t("salesOrder.recipientProvince")), 1),
                            _createElementVNode("div", _hoisted_352, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address.recipient_province), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.shipping_address.recipient_country
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            _createElementVNode("div", _hoisted_353, _toDisplayString(_ctx.t("salesOrder.recipientCountry")), 1),
                            _createElementVNode("div", _hoisted_354, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address.recipient_country), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("template", null, [
                        _createElementVNode("div", _hoisted_355, _toDisplayString(_ctx.t("salesOrder.destinationZone")), 1),
                        _createElementVNode("div", _hoisted_356, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address.destination_zone), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (!_ctx.isAuditView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_357, [
                _createElementVNode("div", _hoisted_358, [
                  _createElementVNode("div", _hoisted_359, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.t("salesOrder.paymentInformation")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_360, [
                    _createElementVNode("span", _hoisted_361, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_362, [
                  _createElementVNode("div", _hoisted_363, [
                    _createElementVNode("div", _hoisted_364, [
                      (
                    _ctx.salesOrderOverviewData.payment_information.payment_method
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_365, [
                            _createElementVNode("div", _hoisted_366, _toDisplayString(_ctx.t("salesOrder.paymentMethod")), 1),
                            _createElementVNode("div", _hoisted_367, _toDisplayString(_ctx.salesOrderOverviewData.payment_information.payment_method), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.payment_information.payment_status
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_368, [
                            _createElementVNode("div", _hoisted_369, _toDisplayString(_ctx.t("salesOrder.paymentStatus")), 1),
                            _createElementVNode("div", _hoisted_370, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge uppercase", 
                        _ctx.paymentStatus(
                          _ctx.salesOrderOverviewData.payment_information
                            .payment_status
                        ).statusClass
                      ])
                              }, _toDisplayString(_ctx.paymentStatus(
                          _ctx.salesOrderOverviewData.payment_information
                            .payment_status
                        ).str), 3)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.sales_order.deposit_payment_status
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_371, [
                            _createElementVNode("div", _hoisted_372, _toDisplayString(_ctx.t("salesOrderOverview.despositStatusIfAvailable")), 1),
                            _createElementVNode("div", _hoisted_373, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", 
                        _ctx.orderDepositPaymentStatus(
                          _ctx.salesOrderOverviewData.sales_order
                            .deposit_payment_status
                        ).statusClass
                      ])
                              }, _toDisplayString(_ctx.orderDepositPaymentStatus(
                          _ctx.salesOrderOverviewData.sales_order
                            .deposit_payment_status
                        ).str), 3)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.salesOrderOverviewData.billing_address
                      .billing_street_address
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_374, [
                            _createElementVNode("div", _hoisted_375, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1),
                            _createElementVNode("div", _hoisted_376, _toDisplayString(_ctx.salesOrderOverviewData.billing_address
                        .billing_street_address), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.payment_voucher.length !== 0 && !_ctx.isAuditView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_377, [
                _createElementVNode("div", _hoisted_378, [
                  _createElementVNode("div", _hoisted_379, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.t("salesOrderOverview.proofOfPayment")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_380, [
                    _createElementVNode("span", _hoisted_381, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_382, [
                  _createElementVNode("div", _hoisted_383, [
                    _createElementVNode("div", _hoisted_384, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_385, _toDisplayString(_ctx.t("salesOrderOverview.depositAmount")), 1),
                        _createElementVNode("div", _hoisted_386, _toDisplayString(_ctx.formData.deposit_currency == "CNY"
                        ? _ctx.$currency.currency(
                            _ctx.formData.deposit_amount,
                            2,
                            ".",
                            "",
                            "￥ "
                          )
                        : _ctx.$currency.currency(
                            _ctx.formData.deposit_amount,
                            2,
                            ",",
                            ".",
                            "€ "
                          )), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_387, _toDisplayString(_ctx.t("salesOrderOverview.paymentScreenshot")), 1),
                        _createElementVNode("div", _hoisted_388, [
                          _createElementVNode("div", _hoisted_389, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.payment_voucher, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6",
                                key: index
                              }, [
                                _createElementVNode("div", {
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (_ctx.previewProofOfPayment(index))
                                }, [
                                  _createElementVNode("img", {
                                    src: item.url,
                                    class: "rounded w-100",
                                    alt: ""
                                  }, null, 8, _hoisted_391)
                                ], 8, _hoisted_390)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_validation_rejection_modal, {
      id: _ctx.id,
      type: _ctx.informationType,
      verifiedNotice: _ctx.verifiedNotice,
      onUpdateList: _ctx.refreshInfo,
      onResetForm: _ctx.handleResetVerifiedNotice
    }, null, 8, ["id", "type", "verifiedNotice", "onUpdateList", "onResetForm"])
  ], 64))
}